var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"machine-select-legal-text"},[_c('sup',[_vm._v("*")]),_vm._v(" Alle Preise berechnet auf Basis von 60 Monate Laufzeit exkl. Service. Preise können bei Änderungen variieren. ")])
}]

export { render, staticRenderFns }